var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 17.3332C13.5942 17.3332 17.3332 13.5942 17.3332 8.99984C17.3332 4.40551 13.5942 0.666504 8.99984 0.666504C4.40551 0.666504 0.666504 4.40551 0.666504 8.99984C0.666504 13.5942 4.40551 17.3332 8.99984 17.3332ZM8.99984 1.83952C12.9343 1.83952 16.1602 5.04089 16.1602 8.99984C16.1602 12.9588 12.9343 16.1602 8.99984 16.1602C5.06533 16.1602 1.83952 12.9343 1.83952 8.99984C1.83952 5.06533 5.06533 1.83952 8.99984 1.83952ZM7.60688 12.6654C7.28919 12.6654 7.02037 12.9343 7.02037 13.252C7.02037 13.5696 7.28919 13.8385 7.60688 13.8385H11.4681C11.7858 13.8385 12.0546 13.5696 12.0546 13.252C12.0546 12.9343 11.7858 12.6654 11.4681 12.6654H10.124V7.4846C10.124 7.16691 9.85517 6.89809 9.53748 6.89809H7.60688C7.28919 6.89809 7.02037 7.16691 7.02037 7.4846C7.02037 7.8023 7.28919 8.07111 7.60688 8.07111H8.95096V12.6654H7.60688ZM9.68417 4.96725C9.68417 5.49363 9.25746 5.92033 8.73109 5.92033C8.20472 5.92033 7.77801 5.49363 7.77801 4.96725C7.77801 4.44088 8.20472 4.01417 8.73109 4.01417C9.25746 4.01417 9.68417 4.44088 9.68417 4.96725Z",
    fill: "#677B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionEye);
export default __webpack_public_path__ + "static/media/Union-eye.e3e9e9e7827b65f7e2e96647d555e773.svg";
export { ForwardRef as ReactComponent };